import type { NodeProps } from "reactflow";
import cn from "classnames";
import { BlockStep, StringBlockStep } from "app/lib/pipeline";
import Icon from "app/components/shared/Icon";
import * as HoverCard from "app/components/Playground/HoverCard";
import BaseNode from "../BaseNode";
import unblockImg from "app/images/playground/unblock_button.png";

const BlockStepNodeIcon = () => (
  <div aria-hidden={true} className="bg-charcoal-300 p-2 rounded-lg">
    <Icon className="text-white h-6 w-6" icon="heroicons/solid/pause" />
  </div>
);

const getLabel = (step: BlockStep | StringBlockStep) => {
  if (typeof step === "string") {
    return "Block";
  }

  return step.block || "Block";
};

export default function BlockStepNode(
  props: NodeProps<BlockStep | StringBlockStep>,
) {
  return (
    <HoverCard.Trigger
      payload={{
        id: props.id,
        content: (
          <>
            <img
              alt="Screenshot of Block step in the Buildkite UI"
              className="aspect-video object-cover"
              src={unblockImg}
            />
            <HoverCard.Content id={props.id} label="Block step">
              A <em>block</em> step is used to pause the execution of a build
              and wait on a team member to unblock it using the web or the API.
            </HoverCard.Content>
          </>
        ),
      }}
      className="group"
    >
      <BaseNode
        {...props}
        label={getLabel(props.data)}
        icon={<BlockStepNodeIcon />}
        className="cursor-help group-focus:bg-gray-100 group-hover:bg-gray-100"
      />
    </HoverCard.Trigger>
  );
}
